module.exports = __webpack_public_path__ + "static/media/artajasa.73fb72f6.png";